// extracted by mini-css-extract-plugin
export default {"schoolSelect":"SchoolSelector__schoolSelect___xHljA"};